import http from '../.././http';

// 菜单
export function getMenuTree(params) {
  return http.get('/menu/findMenuTree', { params });
}

/**
 * 前台接口
 */

// 菜单
export function getMenus(params) {
  return http.get('Home/FindMenus', { params });
}

// 轮播图
export function getBannerList(params) {
  return http.get('Home/findHomePictureList', { params });
}

// 分类
export function getCategoryList(params) {
  return http.get('home/findCategoryList', { params });
}

// 内容
export function getContentList(params) {
  return http.get('home/findHmContentList', { params });
}